import { render, staticRenderFns } from "./select-input.vue?vue&type=template&id=0b134380"
import script from "./select-input.vue?vue&type=script&lang=js"
export * from "./select-input.vue?vue&type=script&lang=js"
import style0 from "./select-input.vue?vue&type=style&index=0&id=0b134380&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports